"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M3.487 2.153c.807-.806 2.196-.845 3.059-.115l.125.115 2.537 2.538c.667.666.845 1.654.47 2.507l-.078.158-1.492 2.78a8.582 8.582 0 0 0 5.793 5.996l.284.081 2.772-1.492a2.276 2.276 0 0 1 2.538.275l.128.117 2.221 2.222c.424.415.656.977.656 1.582a2.24 2.24 0 0 1-.526 1.447l-.136.148-1.318 1.319c-.42.426-.999.67-1.59.67-.055 0-.11 0-.165-.008A18.871 18.871 0 0 1 1.505 5.236a2.231 2.231 0 0 1 .54-1.63l.123-.133 1.319-1.32Zm1.596.279c-.305 0-.592.1-.824.285l-.11.099-1.326 1.326a1.281 1.281 0 0 0-.385 1.018 17.94 17.94 0 0 0 16.409 16.4c.327.02.657-.086.912-.29l.104-.094 1.326-1.325a1.31 1.31 0 0 0 .385-.934c0-.299-.1-.585-.286-.822l-.1-.113-2.22-2.222a1.325 1.325 0 0 0-1.433-.287l-.13.062-2.939 1.585a.42.42 0 0 1-.343.035 9.468 9.468 0 0 1-6.967-6.972.462.462 0 0 1 .011-.254l.035-.082L8.786 6.91a1.315 1.315 0 0 0-.134-1.456l-.098-.109-2.538-2.53a1.339 1.339 0 0 0-.933-.383Zm7.468 4.207a4.433 4.433 0 0 1 4.421 4.42c0 .222-.11.332-.11.443-.11.11-.332.11-.442.11-.331 0-.553-.221-.553-.552 0-1.88-1.437-3.316-3.316-3.316-.331 0-.552-.221-.552-.553 0-.331.221-.552.552-.552Zm0-2.211c3.648 0 6.632 2.985 6.632 6.632 0 .22-.111.33-.111.442-.11.11-.331.11-.441.11-.332 0-.553-.221-.553-.552 0-3.095-2.432-5.526-5.527-5.526-.331 0-.552-.221-.552-.553 0-.332.221-.553.552-.553Zm0-2.21c4.864 0 8.842 3.979 8.842 8.842 0 .22-.11.33-.11.442-.11.11-.332.11-.442.11-.332 0-.553-.221-.553-.552a7.689 7.689 0 0 0-7.737-7.737c-.331 0-.552-.221-.552-.552 0-.332.221-.553.552-.553Z",
    clipRule: "evenodd"
  })]
});